export const SAVE_MODULE_START = 'SAVE_MODULE_START';
export const SAVE_MODULE_COMPLETE = 'SAVE_MODULE_COMPLETE';
export const SAVE_MODULE_ERROR = 'SAVE_MODULE_ERROR';
export const SAVE_MODULE_WEBHOOK_ERROR = 'SAVE_MODULE_WEBHOOK_ERROR';
export const CREATE_MAIN_BRANCH = 'CREATE_MAIN_BRANCH';
export const CLOSE_MODAL = 'CLOSE_MODAL';
